<template>
    <div class="relative">
        <base-dropdown
            placement="bottom"
            :fill="true"
            @close="reset"
        >
            <input
                slot="trigger"
                slot-scope="{ open }"
                ref="input"
                v-model="search"
                :disabled="disabled"
                :class="{
                    'is-disabled': disabled
                }"
                class="input pl-12"
                placeholder="Search street, town, postcode..."
                @input="get"
                @focus="open"
                @keydown.down.prevent="highlightNext"
                @keydown.up.prevent="highlightPrev"
                @keydown.enter.prevent="selectHighlighted"
            >

            <div
                slot="menu"
                slot-scope="{ close }"
                ref="options"
                class="dropdown-menu w-full max-h-xs mt-3px py-2 overflow-y-auto scrollbar-hidden"
                v-if="options.length && search"
            >
                <template v-if="options.length">
                    <div
                        v-for="(option, index) in options"
                        :key="option.id"
                        :class="{ 'is-active': index === highlighted_index }"
                        class="dropdown-menu-link"
                        @click.prevent="select(option, close)"
                    >
                        {{ option.label }}
                    </div>
                </template>
                <div
                    v-else
                    class="text-grey italic px-3"
                >
                    <template v-if="is_loading">Loading...</template>
                    <template v-else>No results found.</template>
                </div>
            </div>
        </base-dropdown>

        <div class="absolute left-0 inset-y-0 flex items-center pl-4 pointer-events-none">
            <base-svg
                :name="is_loading ? 'icon-loading' : 'icon-search'"
                :key="is_loading ? 'icon-loading' : 'icon-search'"
                class="w-6 h-6"
            />
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import axios from 'axios'

    export default {
        model: {
            prop: 'address',
            event: 'input'
        },
        props: {
            address: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                is_loading: false,
                search: '',
                container: '',
                options: [],
                highlighted_index: -1
            }
        },
        computed: {
            has_pca () {
                return !!this.key
            },
            key () {
                return _.preload('keys.pcapredict')
            },
            ip () {
                return _.preload('ip')
            }
        },
        methods: {
            get () {
                if (_.isEmpty(this.search)) {
                    this.options = []

                    return
                }

                this.is_loading = true

                axios
                    .get('https://api.addressy.com/Capture/Interactive/Find/v1.00/json3.ws', {
                        params: {
                            Key: this.key,
                            Origin: this.ip,
                            Limit: 10,
                            Text: this.search,
                            Container: this.container
                        }
                    })
                    .then(({ data }) => {
                        this.options = _.chain(data)
                            .get('Items')
                            .filter(result => {
                                return [
                                    'Address',
                                    'Street',
                                    'Locality',
                                    'Postcode'
                                ].includes(_.get(result, 'Type'))
                            })
                            .map(result => {
                                return {
                                    id: result.Id,
                                    type: result.Type,
                                    label: [
                                        result.Text,
                                        result.Description
                                    ].join(', ')
                                }
                            })
                            .value()

                        this.is_loading = false
                    })
                    .catch(error => {
                        console.error(error)

                        this.is_loading = false
                    })
            },
            select (option, close) {
                if (option.type !== 'Address') {
                    this.contain(option)
                    return
                }

                this.is_loading = true

                axios
                    .get('https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json3.ws', {
                        params: {
                            Key: this.key,
                            Id: option.id
                        }
                    })
                    .then(({ data }) => {
                        this.$emit('input', {
                            street: _.get(data, 'Items.0.Line1'),
                            locality: _.get(data, 'Items.0.Line2'),
                            village: _.get(data, 'Items.0.Line3'),
                            town: _.get(data, 'Items.0.City'),
                            county: _.get(data, 'Items.0.Province'),
                            postcode: _.get(data, 'Items.0.PostalCode')
                        })

                        close()

                        this.is_loading = false
                    })
                    .catch(error => {
                        console.error(error)

                        this.is_loading = false
                    })
            },
            selectHighlighted () {
                this.select(this.options[this.highlighted_index])
            },
            contain (option) {
                this.container = option.id

                this.get()
            },
            reset () {
                this.container = ''

                this.highlighted_index = -1

                this.$refs.input.blur()
            },
            highlightNext () {
                this.highlight(this.highlighted_index + 1)
            },
            highlightPrev () {
                this.highlight(this.highlighted_index - 1)
            },
            highlight (index) {
                this.highlighted_index = index

                if (this.highlighted_index < 0) {
                    this.highlighted_index = this.options.length - 1
                }

                if (this.highlighted_index > this.options.length - 1) {
                    this.highlighted_index = 0
                }

                this.$refs.options.children[this.highlighted_index].scrollIntoView({
                    block: 'nearest'
                })
            }
        }

    }
</script>
